import type { KeyboardEvent } from "react";

/** Activate a clickable table row from Enter/Space, ignoring nested controls. */
export const activateRowOnKey = (event: KeyboardEvent, activate: () => void) => {
  if (event.target !== event.currentTarget) return;
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    activate();
  }
};
